module.exports = __webpack_public_path__ + "static/media/Rueda-Final.28148de5.jpg";